//@ts-check
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '../../../../core/Button';
import dompurify from 'dompurify';
var sanitizer = dompurify.sanitize;
/**
 * @param {import('./types').ButtonsProps} params
 */

var Buttons = function Buttons(_ref) {
  var showBack = _ref.showBack,
      showNext = _ref.showNext,
      showSubmit = _ref.showSubmit,
      onNext = _ref.onNext,
      onPrevious = _ref.onPrevious,
      onSubmit = _ref.onSubmit,
      pageNumber = _ref.pageNumber,
      backButtonContent = _ref.backButtonContent,
      continueButtonContent = _ref.continueButtonContent,
      submitButtonContent = _ref.submitButtonContent,
      disableSubmitButton = _ref.disableSubmitButton;
  var backButton = {
    __html: sanitizer(backButtonContent) || 'Back'
  };
  var continueButton = {
    __html: sanitizer(continueButtonContent) || 'Continue'
  };
  var submitButton = {
    __html: sanitizer(submitButtonContent) || 'Finish'
  };
  return React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "space-between",
    alignItems: "center",
    style: {
      marginTop: 20
    },
    className: "form-navigation"
  }, React.createElement(Grid, {
    item: true
  }, showBack && React.createElement(Button, {
    onClick: onPrevious
  }, React.createElement("span", {
    dangerouslySetInnerHTML: backButton
  }))), React.createElement(Grid, {
    item: true
  }), React.createElement(Grid, {
    item: true,
    className: "form-submit"
  }, showNext && React.createElement(Button, {
    onClick: onNext
  }, React.createElement("span", {
    dangerouslySetInnerHTML: continueButton
  })), showSubmit && React.createElement(Button, {
    onClick: onSubmit,
    className: "btn",
    disabled: disableSubmitButton
  }, React.createElement("span", {
    dangerouslySetInnerHTML: submitButton
  }))));
};

export default React.memo(Buttons);